import Country from "./models/Country"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getCountries = () => ObservableFromFetch<Country[]>("Countries/List")
